import api from "./api";

export const createPayment = async (payload) => {
    try {
        const response = await api.post('/payments', payload);
        if (response.status === 200) return response.data;
        return false;
    } catch (error) {
        console.log("Error creating payment:", error);
        return false;
    }
}

export const getAllPayments = async (uuidAccount) => {
    try {
        const response = await api.get('/payments', {
            params: {uuidAccount}
        });
        if (response.status === 200) return response.data;
        return false;
    } catch (error) {
        console.log("Error fetching payments:", error);
        return false;
    }
}

export const getSetupIntent = async (uuidAccount) => {
    try {
        const response = await api.post('/payments/methods', {uuidAccount});
        if (response.status === 200) return response.data;
        return false;
    } catch (error) {
        console.log("Error fetching setup intent:", error);
        return false;
    }
}